module.exports = __webpack_public_path__ + "media/components/assets/icons/congratu-d1f52ee251952e9bcb6f2445ff6b1ace.svg";